import { useState } from 'react'

/**
 * Custom hook for managing panel minimization state
 * Handles spot mode panel and search panel toggle states
 * 
 * @returns {Object} - Panel state and setters
 */
export function usePanelState() {
  const [isSpotPanelMinimized, setIsSpotPanelMinimized] = useState(false) // Toggle for spot mode panel
  const [isSearchPanelMinimized, setIsSearchPanelMinimized] = useState(false) // Start expanded (not minimized)

  return {
    isSpotPanelMinimized,
    setIsSpotPanelMinimized,
    isSearchPanelMinimized,
    setIsSearchPanelMinimized
  }
}
